const HeroSection = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-white via-emerald-50/30 to-white pt-16">
      {/* Background decoration */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-emerald-100/40 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 left-0 w-64 h-64 bg-amber-100/30 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 w-full py-14 sm:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          {/* Left content */}
          <div className="flex-1 min-w-0 text-center lg:text-left">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white border border-emerald-200 text-emerald-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 anim-fade-up">
              <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full inline-block" />
              Pago único • Sin suscripciones • Para siempre
            </div>

            {/* Headline */}
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-900 leading-tight mb-5 anim-fade-up-1" style={{ fontFamily: "'Syne', sans-serif" }}>
              Deja de perder dinero en{' '}
              <span className="relative inline-block">
                <span className="relative z-10 text-red-400 line-through decoration-2">cuadernos que se pierden</span>
              </span>{' '}
              y{' '}
              <span className="relative">
                <span className="relative z-10">Excels que no entiendes.</span>
                <span className="absolute -bottom-1 left-0 right-0 h-3 bg-amber-200/60 -z-0 rounded" />
              </span>
            </h1>

            {/* Subtitle */}
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0 anim-fade-up-2">
              Toma el <strong className="text-gray-800 font-semibold">control total de tu inventario</strong> con StockSimple. La herramienta visual diseñada para dueños de tiendas que necesitan saber qué hay, qué falta y qué se vende,{' '}
              <em>sin complicaciones técnicas.</em>
            </p>

            {/* CTA Button */}
            <div className="anim-fade-up-3 flex flex-col sm:flex-row items-center lg:items-start gap-4">
              <button
                onClick={() => scrollTo('checkout')}
                className="group inline-flex items-center gap-3 bg-emerald-500 hover:bg-emerald-600 text-white text-base sm:text-lg font-bold px-6 sm:px-8 py-4 rounded-xl transition-all cursor-pointer text-center leading-snug w-full sm:w-auto justify-center"
              >
                <i className="ri-shopping-cart-line text-xl flex-shrink-0" />
                <span>¡Quiero StockSimple<br className="sm:hidden" /> por solo S/20!</span>
                <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform flex-shrink-0 hidden sm:inline" />
              </button>
            </div>
            <div className="mt-4 flex flex-wrap items-center justify-center lg:justify-start gap-3 sm:gap-4 text-xs sm:text-sm text-gray-500">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line text-emerald-500" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-lock-line text-emerald-500" />
                Pago seguro
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-timer-line text-emerald-500" />
                Lista en 5 min
              </span>
            </div>
          </div>

          {/* Right: Vimeo Video */}
          <div className="w-full lg:w-[52%] flex-shrink-0 anim-fade-in">
            {/* Label encima del video */}
            <div className="flex items-center justify-center mb-3">
              <span className="inline-flex items-center gap-2 bg-emerald-500 text-white text-xs sm:text-sm font-bold px-5 py-2 rounded-full shadow-lg tracking-wide uppercase">
                <span className="flex items-center justify-center w-5 h-5">
                  <i className="ri-play-circle-fill text-base" />
                </span>
                Ver Video Demo
              </span>
            </div>
            <div className="relative rounded-2xl overflow-hidden border border-gray-200/80 bg-black">
              {/* 16:9 aspect ratio wrapper */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  src="https://player.vimeo.com/video/1177367204?badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  className="absolute inset-0 w-full h-full"
                  title="StockSimple Demo"
                />
              </div>
            </div>
            {/* Video caption */}
            <p className="text-center text-xs text-gray-400 mt-3 flex items-center justify-center gap-1.5">
              <i className="ri-play-circle-line text-emerald-500 text-sm" />
              Mira cómo funciona StockSimple en menos de 2 minutos
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
